import { MenuAction } from '@shared/interfaces/header/menu-action';
import { MailCheck, Pencil, PlusCircle, SidebarClose } from 'lucide-angular';

export const meteringpointPricingActionMenu: MenuAction[] = [
  {
    id: 'add',
    title: 'common.add',
    icon: PlusCircle,
    breaker: true,
  },
  {
    id: 'edit',
    title: 'common.edit',
    icon: Pencil,
  },
  {
    id: 'close',
    title: 'common.stop',
    icon: SidebarClose,
    breaker: true,
  },
  {
    id: 'request',
    title: 'meteringpoint.pricing.requestMasterDataCharge',
    icon: MailCheck,
  }
];
